module.exports = __webpack_public_path__ + "static/img/getAPI.d369f2c.svg";


//////////////////
// WEBPACK FOOTER
// ./static/website/images/getAPI.svg
// module id = S9xd
// module chunks = 1